import React, { useCallback, useState } from 'react'
import { Card, CardBody, CardHeader } from 'reactstrap'
import { TitlePage } from 'components/atoms'
import MerchantOutboundReturnTable from 'domains/merchant-outbound-return/organisms/table'
import MerchantOutboundReturnsApiV2 from 'api/v2/admins/merchant-outbound-returns-api-v2'
import RedirectButton from 'components/atoms/redirect-button'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const MerchantOutboundReturnListPage = ({ pageUtils }) => {
  const [ outboundReturns, setOutboundReturns ] = useState([])
  const [ pagination, setPagination ]           = useState({})
  const [ isLoading, setIsLoading ]             = useState(false)
  const history                                 = useHistory()

  const handleFetchOutboundReturn = async (tableState) => {
    setIsLoading(true)
    await MerchantOutboundReturnsApiV2.get({ tableState: tableState })
      .then((response) => {
        setOutboundReturns(response.data.outbound_returns)
        setPagination(response.data.meta)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
      .finally(() => setIsLoading(false))
  }

  // Goes to ReceiveDetail Page when clicking on the row button
  const handleSelectRow = useCallback((datum) => {
    const id = datum.id
    history.push({
      pathname: `${id}/detail`
    })
  }, [ history ])

  return (
    <>
      <TitlePage mainTitle='Merchant Outbound Returns' subTitle='' />

      <Card>
        <CardHeader>
          <RedirectButton
            color='success'
            size='sm'
            text={ '+ Add New Merchant Outbound Return' }
            path={ 'create' }
          />
        </CardHeader>
        <CardBody>
          <MerchantOutboundReturnTable
            data={ outboundReturns }
            pagination={ pagination }
            onFetchData={ handleFetchOutboundReturn }
            hiddenColumns={ [] }
            isLoading={ isLoading }
            rowButtonProps={{
              buttonText    : 'Detail',
              buttonColour  : 'primary',
              onButtonClick : handleSelectRow
            }}
          />
        </CardBody>
      </Card>
    </>
  )
}

MerchantOutboundReturnListPage.propTypes    = propTypes
MerchantOutboundReturnListPage.defaultProps = defaultProps

export default MerchantOutboundReturnListPage
